module.exports = __webpack_public_path__ + "static/media/20110524_4515.726d9972.jpg";